import { post, get } from '../api.service';

/**
 * Fetches news articles by slug from the backend API.
 * @param payload - The request payload containing the slug or related data.
 * @returns The API response with the news article data.
 */
export const fetchNewsBySlug = async (slug: string) => {
    return await get(`newsarticle/${slug}`);
};

/**
 * Fetches paginated news articles with optional search and date filters.
 * @param payload - The request payload containing page number, page size, search text, from date, and to date.
 * @returns The API response with the paginated news articles.
 */
export const fetchPaginatedNews = async (payload: any) => {
    return await get('NewsArticle', payload);
};

export const searchNews = async (payload: any) => {
    return await get('NewsArticle', payload);
};
